module.exports = __webpack_public_path__ + "imgs/urban-p2x.eebd5613.webp";